define('views/content/go_order_licenses',['require','views/base/list_page_view','views/components/go_order/licenses','collections/go_order_licenses','text!templates/content/go_order_licenses.html'],function (require) {
  var BaseListPageView = require("views/base/list_page_view");

  var GoOrderLicensesView = require("views/components/go_order/licenses");
  var GoOrderLicensesCollection = require("collections/go_order_licenses");

  var temp = require("text!templates/content/go_order_licenses.html");

  return BaseListPageView.extend({
    // html template for the view
    template: _.template(temp),
    className: "go-order-licenses-page",

    setCollection: function () {
      var collection = new GoOrderLicensesCollection();
      collection.changeFilter("productId", this.id);
      this.collection = collection;
    },

    onRender: function () {
      this.ListContainer.show(
        new GoOrderLicensesView({
          collection: this.collection,
        })
      );
    },
  });
});

